import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import './login.css';
import Message from '../../components/ui/Message';
import logoDefault from '../../assets/images/default/logo_beepay.png'
import logoGlobal from '../../assets/images/global/logo_white.svg'
import logoLafise from '../../assets/images/lafise/logo_lafise.svg'
import logoBNCR from '../../assets/images/bncr/logo_bncr.svg'

import { User } from '../../models/interfaces';


const Login = () => {
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [enableBtlLogin, setEnableBtnLogin] = useState(false);
  const navigate = useNavigate();
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [confirmarReset, setConfirmarReset] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const env = process.env.REACT_APP_ENV;


  const { status, login, errorMessage, successMessage, removeError, resetPassword } = useContext(AuthContext);

  useEffect(() => {
    const storedEmail = localStorage.getItem('usuarioLogin');

    if (storedEmail) {
      setUser(storedEmail);
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000);
  }, []);

  useEffect(() => {
    setEnableBtnLogin(user.length > 0 && password.length > 0)
  }, [user, password]);

  useEffect(() => {

    const company = process.env.REACT_APP_COMPANY;
    let url;

    switch (company) {

      case 'global':
        url = logoGlobal;
        break;
      case 'lafise':
        url = logoLafise;
        break;
      case 'bncr':
        url = logoBNCR;
        break;
      default:
        url = logoDefault;
        break;
    }

    setLogoUrl(url);
  }, []);

  const processOtp = async (otp: string) => {
    login({
      correo: user,
      password: password,
      retry: true,
      otp: otp
    })

  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(prev => !prev);
  };


  const handleLogin = (e: any) => {
    e.preventDefault();

    if (env.toLowerCase() != 'dev') {

      const ORACLE_HOST = process.env.REACT_APP_ORACLE_HOST;
      const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
      const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);

      const state = Array.from(array)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');

      sessionStorage.setItem("oauth_state", state);

      const authUrl =
        `${ORACLE_HOST}/oauth2/v1/authorize` +
        `?response_type=code` +
        `&client_id=${CLIENT_ID}` +
        `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
        `&scope=openid profile email` +
        `&state=${state}`;

      window.open(authUrl, "_self");
    }
    else {
      login({ correo: user, password, retry: false, otp: '' });
    }

  };

  const handleConfirmResetPassword = (e: any) => {
    e.preventDefault();
    setConfirmarReset(true);

  }

  const handleResetPassword = (e: any) => {
    //e.preventDefault();
    setConfirmarReset(false);
    resetPassword(user);

  }



  return (
    <div>
      {
        status == "checking" ?
          (
            <div className="d-flex justify-content-center">
              <div className="spinner-border  text-info mt-5" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )
          :
          (

            <div className={`wrapper ${isLoading ? 'fadeInDown' : ''}`} >
              <div id='header' className='headerLogin'>
                <img src={logoUrl} alt='Logo' className='logo'></img>
              </div>
              <div id='formContent'>
                {

                  <form>
                    <div className='row'>
                      <h4 className='text-center' style={{ color: 'var(--secundary-color)' }}>Bienvenido al</h4>
                      <h4 className='text-center' style={{ color: '#414040' }}>Portal de Beepay</h4>
                    </div>
                    <div style={{ height: '50' }}></div>
                    {env.toLowerCase() == 'dev' && <div> <div className="mb-3 row ">
                      <label htmlFor="email" className="form-label">
                        Usuario
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Usuario"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                      />
                    </div>


                      <div className="mb-3 row">
                        <label htmlFor="password" className="form-label">
                          Contraseña
                        </label>
                        <div className="input-group" style={{ paddingLeft: '0', paddingRight: '0' }}>
                          <input
                            type={passwordVisible ? 'text' : 'password'}
                            className="form-control border-end-0"
                            id="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i
                              className={passwordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'}
                              onClick={togglePasswordVisibility}
                              style={{ cursor: 'pointer' }}
                            />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 form-check" >
                        <div style={{ float: 'left', display: 'inline-block' }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={() => setRememberMe(!rememberMe)}
                          />
                          <label className="form-check-label" htmlFor="rememberMe">
                            Recordar usuario
                          </label>
                        </div>
                        <div style={{ float: 'right', display: 'inline-block' }}>
                          <a href='' onClick={(e) => handleConfirmResetPassword(e)} style={{ textDecoration: 'none' }}>¿Olvidó la contraseña?</a>
                        </div>
                      </div> </div>}


                    <div className='text-center'>
                      <button
                        style={{ width: '150px', marginTop: '6%', backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}
                        //type="b"
                        name='Iniciar sesión'
                        className="btn btn-primary"
                        //disabled={!enableBtlLogin}
                        onClick={handleLogin}

                      >
                        Iniciar sesión
                      </button>

                      <div style={{ height: '75px' }}></div>


                    </div>
                  </form>
                }
              </div>
            </div>
          )
      }
      {
        errorMessage.length > 0
          ?
          errorMessage == "Te enviamos un OTP al correo. Ingresa el código para continuar." ?
            <Message type='error'
              message={errorMessage}
              closeDialog={removeError}
              //handleOk={removeError}
              handleOk={(otp) => processOtp(otp)}
              backgroundColor='rgba(0,0,0,0.4)'
              showReasonField={true}
              reasonLabel='OTP'
              rows={1}
              maxLength={6}
            /> :
            <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' />
          : ''
      }

      {
        successMessage.length > 0 ? <Message type='success' message={successMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
      }

      {
        confirmarReset ? <Message type='success' message="¿Necesitas restablecer tu contraseña? Por favor, confirma a continuación." closeDialog={() => { setConfirmarReset(false) }} handleOk={(e) => handleResetPassword(e)} backgroundColor='rgba(0,0,0,0.4)' /> : ''
      }
    </div>



  );
};




export default Login;
